export function isString(value) {
    return typeof value === 'string';
}
export function assertIsString(value) {
    if (!isString(value)) {
        throw new TypeError(`Value is not of type string.`);
    }
}
export function createStringLiteral(value) {
    return value;
}
//# sourceMappingURL=string.js.map